import * as React from "react";
import { Button } from "./Button";

type Props = {
  title: string;
  /** outline = full bordered CTA (reading result); ghost = compact muted link;
   *  link = text-only link tone (review card on All Reviews). */
  variant?: "outline" | "ghost" | "link";
};

export function ShareButton({ title, variant = "outline" }: Props) {
  const [toast, setToast] = React.useState<string | null>(null);

  const handleClick = async () => {
    const url = window.location.href;
    try {
      if (typeof navigator.share === "function") {
        await navigator.share({ title, url });
        return;
      }
    } catch {
      // user cancelled — fall through to clipboard
    }
    try {
      await navigator.clipboard.writeText(url);
      setToast("Link copied");
      window.setTimeout(() => setToast(null), 2000);
    } catch {
      setToast("Couldn't copy — long-press to share");
      window.setTimeout(() => setToast(null), 3000);
    }
  };

  return (
    <div className="relative inline-block">
      <Button variant={variant} surface="light" onClick={handleClick} leftIcon="share">
        Share
      </Button>
      {toast && (
        <div
          role="status"
          className="absolute left-1/2 -translate-x-1/2 top-full mt-2 whitespace-nowrap text-small text-primary"
        >
          {toast}
        </div>
      )}
    </div>
  );
}
